import { useEffect, useRef } from 'react';
import { useIaJobs } from '../context/IaJobsProvider';
import { useOnboardingPack } from '../context/OnboardingPackProvider';

/**
 * Barra «Rever» abre o WorkoutWizardModal no step de revisão.
 */
export default function IaOnboardingReviewHost() {
  const { registerOnboardingReviewOpen } = useIaJobs();
  const { openWizard, suggestions } = useOnboardingPack();
  const suggestionsRef = useRef(suggestions);
  suggestionsRef.current = suggestions;

  useEffect(() => {
    return registerOnboardingReviewOpen(() => {
      if (suggestionsRef.current.length > 0) {
        openWizard({ mode: 'voluntary', contextLabel: 'plan_wizard', step: 'review' });
      }
    });
  }, [registerOnboardingReviewOpen, openWizard]);

  return null;
}
